import processService from "../../services/processService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new processService();
export const getProcessList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_ROWS,
      payload: { ...initialState, loading: true },
    });
    
    service
      .getProcessData(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_ROWS,
          payload: { data: res.data.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_ROWS,
          payload: {
            ...initialState,
            msg: "error",
            loading: false,
            next: false,
          },
        });
      });
  };
};

export const getProcessDropdown = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_DROPDOWN,
      payload: { ...initialState, loader: true },
    });
    service
      .getProcessDropdown(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_DROPDOWN,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_DROPDOWN,
          payload: {
            ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};


export const editFormData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.EDIT_PROCESS_DATA,
      payload: { ...initialState, loading: true },
    });
    return service
      .EditFormData(data)
      .then((res) => {
        dispatch({
          type: types.EDIT_PROCESS_DATA,
          payload: { data: res.data.data, loading: false },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.EDIT_PROCESS_DATA,
          payload: {
             ...initialState,
            message: error?.response?.data?.error || "Error fetching limit dropdown",
            loading: false,
            next: false,
          },
        });
        throw error;
      });
  };
};

export const clearResponse = () => (dispatch) => {
  dispatch({
    type: types.FETCH_ROWS,
    payload: {
      loading: false,
      error: false,
      message: "",
      data: null,
      success: false,
    },
  });
};
